import { ApiResponse } from '../types/api';
import { GetApplicationResponse } from '../types/api/application';
import { lifeApi } from './base';

const getApplication = lifeApi.injectEndpoints({
  endpoints: (builder) => ({
    getApplication: builder.query<
      ApiResponse<GetApplicationResponse>,
      { refId: string }
    >({
      query: ({ refId }) => ({
        url: `/applications`,
        method: 'GET',
        params: {
          refId: refId,
        },
      }),
    }),
  }),
});

export const { useGetApplicationQuery, useLazyGetApplicationQuery } =
  getApplication;
